<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth0 } from '@auth0/auth0-vue';
import { useAuthService } from '@/services/auth.service';
import { safeTarget } from '@/utils/navigation';

const router = useRouter();
const { isAuthenticated, isLoading } = useAuth0();
const { getAndClearLogoutReturnUrl } = useAuthService();

onMounted(() => {
  // Wait for Auth0 to complete authentication before redirecting
  const checkAuth = setInterval(() => {
    // If Auth0 completed loading, redirect appropriately
    if (!isLoading.value) {
      clearInterval(checkAuth);
      if (isAuthenticated.value) {
        // First check for logout return URL (higher priority)
        const logoutReturnUrl = getAndClearLogoutReturnUrl();
        if (logoutReturnUrl) {
          // Redirect to the URL where user was before logout
          window.location.href = logoutReturnUrl;
          return;
        }
        
        // Fall back to originally intended route or default
        const targetUrl = safeTarget(sessionStorage.getItem('authTargetUrl'));
        sessionStorage.removeItem('authTargetUrl');
        router.push(targetUrl);
      } else {
        // Redirect back to sign in if authentication failed
        router.push('/signin');
      }
    }
  }, 50); // Check every 50ms
});
</script>

<template>
  <div class="d-flex justify-content-center align-items-center min-vh-100">
    <div class="text-center">
      <h2>Authenticating...</h2>
      <div class="spinner-border text-success mt-3" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</template>
